<div class="widget widget-textarea">
    <textarea
        #textareaElement
        [name]="name"
        [placeholder]="placeholder"
        [required]="required ? true : false"
        [rows]="rows"
        [maxlength]="maxlength"
        (ngModelChange)="onContentChange($event)"
        [(ngModel)]="content">
    </textarea>
    <div class="widget-counter" *ngIf="maxlength">{{ 'shared.widget.remaining-chars' | translate : { number: getRemainingChars() } }}</div>
</div>
